// @ts-nocheck

import { GridRenderCellParams } from '@mui/x-data-grid-pro';

export function DataGridCellTextInput(props: GridRenderCellParams) {
  const { value } = props;

  return <div>{value}</div>;
}
